<template>
    <v-dialog
      :value="dialog"
      :fullscreen="!$vuetify.breakpoint.mdAndUp"
      :width="width"
      scrollable
      @input="$emit('input', $event)"
      persistent
      :retain-focus="false"
    >
      <v-card
        :height="height"
      >
        <v-card-title
          class="pa-0"
        >
          <v-toolbar
            class="headline grey lighten-2 pl-2"
            v-bind:class="{ 'toolbar--multiline': multiline  }"
          >
            <v-toolbar-title
              v-if="$slots.title"
            >
              <slot name="title"></slot>
            </v-toolbar-title>

            <v-spacer v-if="closeBtn"></v-spacer>

            <v-btn
              icon
              v-if="closeBtn"
              @click.stop="$emit('input', false)"
            >
              <v-icon class="heading grey--text text--darken-4">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text v-if="$slots.body">
          <slot name="body"></slot>
        </v-card-text>

        <v-divider v-if="$slots.actions"></v-divider>

        <v-card-actions v-if="$slots.actions">
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: true,
    },
    closeBtn: {
      type: Boolean,
      default: true,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
    height: [String, Number],
    width: {
      type: Number,
      default: 1000,
    },
  },
};
</script>

<style lang="scss">
  .v-toolbar.toolbar--multiline {
    height: initial !important;

    > .v-toolbar__content {
      height: initial !important;

      .v-toolbar__title {
        white-space: normal;
        word-break: normal;
      }
    }
  }
</style>
